import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Link, Typography } from '@coolblue-development/freddy';
import clickProductSupportTrigger from '@coolblue-development/ga4-events/triggers/LastOrderBlock/clickProductSupportTrigger';
import selectProductTrigger from '@coolblue-development/ga4-events/triggers/LastOrderBlock/selectProductTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { Image } from '@coolblue-development/next-image/client';
import { useTranslation } from '../../i18n/useTranslation.js';
export const ProductCard = ({ product, orderDetailsUrl }) => {
    const { t } = useTranslation('productCard');
    const { trackEvent } = useAnalytics();
    return (_jsxs(Flex, { alignItems: "center", mr: 300, children: [product.imageId && (_jsx(Link, { mr: 400, href: orderDetailsUrl, onClick: () => {
                    trackEvent(selectProductTrigger({
                        method: 'image',
                        item_id: product.id,
                    }));
                }, children: _jsx(Image, { imageId: product.imageId.toString(), fileCollection: "product", width: 100, height: 100, loading: "eager", alt: "" }) })), _jsxs(Flex, { direction: "column", children: [_jsx(Link, { sx: { '&:hover': { textDecoration: 'none' } }, href: orderDetailsUrl, onClick: () => {
                            trackEvent(selectProductTrigger({
                                method: 'title',
                                item_id: product.id,
                            }));
                        }, children: _jsx(Typography, { variant: "h3", children: product.title }) }), product.productHelpUrl && (_jsx(Link, { href: product.productHelpUrl, onClick: () => {
                            trackEvent(clickProductSupportTrigger({
                                item_id: product.id,
                            }));
                        }, children: t('helpWithProduct') }))] })] }));
};
//# sourceMappingURL=ProductCard.js.map